// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/queue-list.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/queue-list'

import { Icon, type IconComponentProps } from '../icon'

export const QueueListIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
